import React, {Fragment, useEffect, useState} from "react";

import {
    defaultTableHeaderStyles,
    defaultPaginationOptions,
    customHeaderStyle,
    defaultTopRightCellStyle
} from "../../Tables/BaseTableComponents";

import PassportTable, {xlateBootstrapTableColumns} from "../../Tables/PassportTable";
import SpinnerDiv from "../../ui/ReactSpinnerDiv";
import {getSchoolConcernReports} from "../../DataFunctions/ConcernReportDataFns";
import {getDataFromResponse} from "../../DataFunctions/BaseDataFns";
import useModalAddConcernReport from "../Modals/ConcernReport/useModalAddConcernReport";
import ActionButton from "../ActionButton";

const ConcernReportTable = ({ school_id }) => {

    const [data, setData] = useState({ isLoading: true, data: [] });
    const [renderConcernReportModal, showConcernReportModal] = useModalAddConcernReport((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    });

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        if(school_id !== undefined)
        {
            getSchoolConcernReports(school_id, (response) =>
            {
                setData({isLoading: false, data: getDataFromResponse(response)});
            });
        }
    };

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        date_created: {width: '5vw' },
        date_opened: {width: '5vw' },
        date_closed: {width: '5vw' },
        status: {width: '10vw'},
        name: {width: '10vw' },
        type: {width: '10vw' },
        message: {width: '40vw' },
        edit: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "5vw"}
    });

    const openConcernReportModal = (cr_id, mode, school_id) => {
        showConcernReportModal(cr_id, mode, school_id);
    };

    const statusRenderer = (cell, row, rowIndex, formatExtraData) => {
        return (
            <Fragment>
                { row.status === 'active' && <i className={'glyphicon glyphicon-warning-sign'} style={{padding:'10px', color:'red'}}/>}
                <span>{row.status}</span>
            </Fragment>
        );
    };

    const toolRenderer = (cell, row, rowIndex, formatExtraData) => {
        return (
            <Fragment>
                {row.status === 'closed' && <i className={'glyphicon glyphicon-eye-open'} onClick={() => openConcernReportModal(row.id, 'view', school_id)} style={{padding:'10px', color:'#4992C9', cursor: 'pointer'}}/>}
                {row.status !== 'closed' && <i className={'glyphicon glyphicon-pencil'} onClick={() => openConcernReportModal(row.id, 'edit', school_id)} style={{padding:'10px', color:'#4992C9', cursor: 'pointer'}}/>}
            </Fragment>
        );
    };

    const getColumns = () => {
        const columns = [
            {
                dataField: 'date_created',
                text: "Date Created",
                search: true,
                sort: true,
                headerStyle: headerStyle,
            },
            {
                dataField: 'open_date',
                text: "Date Opened",
                search: true,
                sort: true,
                headerStyle: headerStyle,
            },
            {
                dataField: 'closing_date',
                text: "Date Closed",
                search: true,
                sort: true,
                headerStyle: headerStyle,
            },
            {
                dataField: 'status',
                text: "Status",
                search: true,
                sort: true,
                headerStyle: headerStyle,
                formatter: statusRenderer
            },
            {
                dataField: 'name',
                text: "Pupil",
                search: true,
                sort: true,
                headerStyle: headerStyle,
            },
            {
                dataField: 'type',
                text: "Type",
                search: true,
                sort: true,
                headerStyle: headerStyle,
            },
            {
                dataField: 'message',
                text: "Message",
                search: true,
                sort: true,
                headerStyle: headerStyle,
            },
            {
                dataField: "edit",
                text: "View/Edit",
                align: "right",
                headerStyle: headerStyle,
                formatter: toolRenderer
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns( getColumns()) ;
    const columns = React.useMemo(() => translations, []) ;

    const tableContent = () =>
    {
        return (
            <Fragment>

                <section>
                    <ActionButton icon='icon-add' onClick={() => openConcernReportModal(null, 'create', school_id)} title="New Concern Report"/>
                </section>

                <PassportTable data={data.data} isLoading={data.isLoading} columns={columns}
                               pagination={defaultPaginationOptions}/>

                {renderConcernReportModal()}
            </Fragment>
        )
    }

    return data.isLoading === true ? <SpinnerDiv /> : tableContent();
};

export default ConcernReportTable;
